import type { Dict } from './index';

/**
 * मराठी. Rupee figures, plan names and statutory terms (80G, 10BD, GST, PAN)
 * stay as they are — that is how they appear on the form.
 */
export const mr: Dict = {
  'Give Setu — the operating system for Indian non-profits.':
    'Give Setu — भारतीय सेवाभावी संस्थांसाठी बनवलेली संपूर्ण प्रणाली.',
  'For established organisations': 'प्रस्थापित संस्थांसाठी',
  'The largest single saving most non-profits will make this year.':
    'या वर्षी बहुतेक संस्था जी सर्वात मोठी बचत करतील, ती हीच.',

  'Get rescue from': 'यातून सुटका मिळवा',
  'All of it. One system.': 'हे सगळं. एकाच प्रणालीत.',
  'Show me the plans': 'प्लॅन दाखवा',
  'Typing 80G receipts by hand at eleven at night in May.':
    'मे महिन्यात रात्री अकरा वाजता हाताने 80G पावत्या बनवणं.',
  'A platform keeping 3% of money that was donated to your cause.':
    'तुमच्या कामासाठी आलेल्या देणगीतून 3% प्लॅटफॉर्मने ठेवून घेणं.',
  '10BD season costing you a fortnight and a chartered accountant.':
    '10BD च्या काळात दोन आठवडे आणि चार्टर्ड अकाउंटंटची फी जाणं.',
  'Not knowing which donor gave last year and has not given this year.':
    'गेल्या वर्षी कोणी दिलं आणि यंदा कोणी नाही, हेच माहीत नसणं.',
  'Paying a developer every single time one page needs changing.':
    'एक पान बदलण्यासाठीही दरवेळी डेव्हलपरला पैसे देणं.',
  'A flood happening on Tuesday and your appeal going live on Friday.':
    'पूर मंगळवारी यावा आणि तुमचं आवाहन शुक्रवारी लाइव्ह व्हावं.',

  'Plans': 'प्लॅन',
  'Everything compared': 'संपूर्ण तुलना, एकाच ठिकाणी',
  'Dedicated CMS portal': 'स्वतःचं समर्पित CMS पोर्टल',
  'CMS portal + a full WordPress website': 'CMS पोर्टल + पूर्ण WordPress वेबसाइट',
  'Full custom-coded UI/UX, included in the plan':
    'पूर्णपणे कस्टम-कोडेड डिझाइन, प्लॅनमध्येच समाविष्ट',
  'New and small organisations': 'नव्या आणि लहान संस्थांसाठी',
  'Established organisations at scale': 'मोठ्या प्रमाणावर काम करणाऱ्या संस्थांसाठी',

  'Website included, free': 'वेबसाइट समाविष्ट, वेगळा खर्च नाही',
  'Active donors': 'सक्रिय देणगीदार',
  'Sleeping / legacy donors': 'निष्क्रिय / जुने देणगीदार',
  '80G receipts per month': 'दरमहा 80G पावत्या',
  'Members': 'सदस्य',
  'Live cases': 'चालू केस',
  'Live campaigns': 'चालू मोहिमा',
  'WhatsApp rail': 'WhatsApp चॅनेल',
  'Marketing emails per month': 'दरमहा मार्केटिंग ईमेल',
  'New design templates each month': 'दरमहा नवीन डिझाइन टेम्पलेट',
  'AI insights': 'AI विश्लेषण',
  'Admin seats': 'अ‍ॅडमिन सीट',
  'Donor & member portals': 'देणगीदार व सदस्य पोर्टल',
  'Compliance Centre (10BD / 10BE)': 'अनुपालन केंद्र (10BD / 10BE)',
  'Unlimited — free': 'अमर्याद — मोफत',
  'Included': 'समाविष्ट',
  'Available from Growth': 'Growth प्लॅनपासून उपलब्ध',
  'Available on Advanced': 'Advanced प्लॅनवर उपलब्ध',
  'Full portal access': 'संपूर्ण पोर्टल प्रवेश',
  'Every template, every month': 'दर महिन्याला, प्रत्येक टेम्पलेट',

  'The website is part of the plan, not a separate purchase.':
    'वेबसाइट प्लॅनचाच भाग आहे, वेगळी खरेदी नाही.',
  'Your data leaves with you. The website does not.':
    'तुमचा डेटा तुमच्यासोबत जातो. वेबसाइट नाही.',

  'What we commit to': 'आम्ही कशाची हमी देतो',
  'Under 4 seconds': '4 सेकंदांपेक्षा कमी',
  'All data, backups and files held in India':
    'सर्व डेटा, बॅकअप आणि फाइल्स भारतातच ठेवल्या जातात',

  'Questions': 'प्रश्न',
  'Do you ever take a commission on donations?':
    'तुम्ही देणगीवर कधी कमिशन घेता का?',
  'BOOK A 20-MINUTE DEMO': '20 मिनिटांचा डेमो बुक करा',
  "See what's included": 'काय काय समाविष्ट आहे ते पाहा',
  'Every rupee acknowledged. Every donor remembered. Every filing ready.':
    'प्रत्येक रुपयाची पावती. प्रत्येक देणगीदार लक्षात. प्रत्येक फाइलिंग तयार.',
};
